import { toleranceFromInput } from "../../LicenseCreateInput/typing/loginstate";
import { LicenceTier, TierFeatures, tierOf } from "./tier";

export { licenceTiers, tierOf } from "./tier";
export type { LicenceTier } from "./tier";

export interface licensedata {
    "uuid": string,
    // Target tolerance in percent (0..100); null = hub default.
    "targetTolerancePercent"?: number | null,
    // Licence tier as the hub reports it (Free, Business, Enterprise).
    "edition"?: string,
    "branch"?: string,
    // Modules ticked on the licence, by name (on top of the tier's features).
    "module"?: string[],
    // Every tier with the modules it includes, from the hub (anima_core LicenceTiers).
    "tierFeatures"?: TierFeatures,
    // Removed (archived) on the hub; activate/verify no longer know it.
    "archived"?: boolean,
    // Unused on the hub (anima_core #7): only such a licence may be removed.
    "unused"?: boolean,
    "licensedTo": string,
    "expirationDate": string,
    "signingDate": string,
    "numberOfTargets": number,
    "licenseFile":string,
    "publicKey":string,
    "privKey":keyfile,
    "mandant": string,
    "uid": string
}
export interface keyfile{
    "uuid":string,
    "content":string,
    "created":string,
}
export interface mandant {
    "uuid": string,
    "name": string,
    "contactList": string,
    "customerList": string,
    "created": string
}




/** A module of the hub's catalog, as GET api/Modules lists it. */
export interface catalogModule {
    uuid: string,
    name: string,
    description: string,
}

export interface tableState {
    model:{
            license:licensedata,
            // The hub default for an empty tolerance; null until the hub said.
            toleranceDefault: number | null,
            // The hub's module catalog; empty until loaded.
            moduleCatalog: catalogModule[],
            // The tier in the select; starts as the hub reports it, saved only when changed.
            selectedTier: LicenceTier | null,
        }
    view:{
        loadeduuid: string,
        loaded: boolean, 
        autorefresh: boolean,
    }
}

export const InitialState : tableState = {
    model:{
        license:
            {
                "uuid": "string",
                "licensedTo": "string",
                "expirationDate": "string",
                "signingDate": "string",
                "numberOfTargets": 0,
                "licenseFile":"string",
                "publicKey":"string",
                "privKey":{
                    "uuid":"string",
                    "content":"string",
                    "created":"string",
                },
                "mandant": "string",
                "uid": "string",
                "targetTolerancePercent": null,
            },
            toleranceDefault: null,
            moduleCatalog: [],
            selectedTier: null,
        }
        ,
        view:{
            loadeduuid :"",
            loaded: false,
            autorefresh: false,
        }
    }


export function deepCopyThingyState(toCopy:tableState):tableState{
    return {
        model:{
            license:{...toCopy.model.license},
            toleranceDefault:toCopy.model.toleranceDefault,
            moduleCatalog:[...toCopy.model.moduleCatalog],
            selectedTier:toCopy.model.selectedTier,
        },
        view:{
            loadeduuid:toCopy.view.loadeduuid,
            loaded:toCopy.view.loaded,
            autorefresh:toCopy.view.autorefresh
        }
    }
}

/** The ticked module names from the checkbox group: strings only, each once. */
export function modulesFromInput(value: unknown): string[] {
    return Array.isArray(value)
        ? value.filter((v): v is string => typeof v === "string" && v.trim() !== "")
               .filter((v, i, all) => all.indexOf(v) === i)
        : [];
}

/**
 * The target count from the number field: a whole number of at least 1, or
 * null for anything else (empty, zero, negative, fractional).
 */
export function targetCountFromInput(value: unknown): number | null {
    return typeof value === "number" && Number.isInteger(value) && value >= 1 ? value : null;
}

export function deepCopyThingyStateAndMerge(toCopy:tableState,FormData:any):tableState{
    const deepCopy = deepCopyThingyState(toCopy);
    if (FormData.type === "targetTolerance")
        deepCopy.model.license.targetTolerancePercent = toleranceFromInput(FormData.data);
    // The select only; the licence keeps the tier the hub reported until saved.
    if (FormData.type === "tier")
        deepCopy.model.selectedTier = tierOf(FormData.data);
    if (FormData.type === "module")
        deepCopy.model.license.module = modulesFromInput(FormData.data);
    // 0 while the field is empty or invalid; the save button stays off then.
    if (FormData.type === "numberOfTargets")
        deepCopy.model.license.numberOfTargets = targetCountFromInput(FormData.data) ?? 0;

//    deepCopy.model.newuser = deepCopy.model.user[0];
    // console.log("FormData");
    
    //  if (FormData.type === "email")
    //      deepCopy.model.user.email = FormData.data
    //  if (FormData.type === "gender")
    //      deepCopy.model.user.gender = FormData.data
    //  if (FormData.type === "name")
    //      deepCopy.model.user.name = FormData.data
    //  if (FormData.type === "role")
    //      deepCopy.model.user.role = FormData.data
    // if (FormData.type === "username")
    //     deepCopy.model.user.username = FormData.data
    // if (FormData.type === "password")
    //     deepCopy.model.user.password= FormData.data
    // if (FormData.type === "passwordverify")
    //     deepCopy.model.user.passwordverification = FormData.data
    return deepCopy;
}